import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";

import gnpRegistro from "../gnp-registro/gnp-registro.css";
import paso from "../gnp-registro-asistido/paso.cmpt";
import Inconvenientes from "./inconvenientes.cmpt";
import Completar from "./completar.cmpt";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.asistido.paso,
		stageValido: state.registro.paso,
		"dispositivo": state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoAsistido: () => {
			dispatch({ "type": "REGISTRO_PASO", paso: 1 });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		}
	};
};

class Flujo extends React.Component {
	atras = () => {
		goTo("gnp/registro");
	}

	componentWillMount = () => {
		if (this.props.stageValido == 1) {
			this.props.pasoAsistido();
		} else {
			this.atras();
		}
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if( url.includes("#!/gnp/registro-asistido") ){
			main.style.width = "1250px";
		}
	}

	render() {
		return (
			<div className="gnpRegistro">
				{this.props.paso == 0 &&
					<div>
						{this.props.dispositivo === "web" ?
							<div className="txt-center">
								<div className="txt-center">
									<div id="title-Registro">
										<label id="txt-Registro">Registro</label>
										<br />
										<hr className="label-hr" />
									</div>
								</div>
								<div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
									<div id="stepper">
										<hr className="hr-poliza2" />
										<label id="label-poliza2">PÓLIZA</label>
									</div>

									<div id="stepper">
										<hr className="hr-contacto2" />
										<label id="label-contacto2">CONTACTO</label>
									</div>

									<div id="stepper">
										<hr className="hr-seguridad2" />
										<label id="label-seguridad2">SEGURIDAD</label>
									</div>
								</div>
							</div> :
							<div className="txt-center">
								<img src={require("../img/Stepper2@2x.svg")} className="pasos-img" alt="step-registro" />
							</div>
						}
						<Completar />
					</div>
				}
				{this.props.paso === 1 && <Inconvenientes />}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/flujo.cmpt.js